/* @flow */

import { getBraindateId } from '@e180/domain/lib/braindate/util';

import PostBraindateFeedbackSuccessNotification from 'src/shared/app/post-braindate/component/PostBraindateFeedbackSuccessNotification';
import PostBraindateFeedbackTakeOver from 'src/shared/app/post-braindate/component/PostBraindateFeedbackTakeOver';
import {
  notificationTakeOverType,
  notificationTopType,
  notificationInfoLevel,
  notificationSuccessLevel,
} from 'src/shared/app/notification/constant/notificationConstants';

import type { Braindate } from '@e180/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

export function getBraindateFeedbackNotificationId(
  braindate: Braindate,
): string {
  return `braindate-feedback-${getBraindateId(braindate)}`;
}

export function convertPostBraindateFeedbackToNotification(
  braindate: Braindate,
): Notification {
  return {
    id: getBraindateFeedbackNotificationId(braindate),
    level: notificationInfoLevel,
    type: notificationTakeOverType,
    componentClass: PostBraindateFeedbackTakeOver,
    data: braindate,
  };
}

export function convertPostBraindateSuccessToNotification(): Notification {
  return {
    id: 'post-braindate-success',
    level: notificationSuccessLevel,
    type: notificationTopType,
    componentClass: PostBraindateFeedbackSuccessNotification,
  };
}
